import React from 'react';
import { StyledFooter } from '../style/style';

function Footer() {
  return <StyledFooter/>
}

export default Footer;
